import React, { Component } from 'react';
import Navbar from '../components/Navbar/Navigation';
import Bio from '../components/Panel/Bio';
import AboutPanel from '../components/Panel/AboutPanel';
import Footer from '../components/Footer/Footer';

class About extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div>
          <AboutPanel />
          <Footer />
        </div>
      </div>
    );
  }
}

export default About;
